import { getNakshatra, nakshatras, type NakshatraId } from "@ishvaram/domain-data/nakshatras";

/**
 * URL and order helpers for the 27 /nakshatra/<slug>/ pages, small enough for
 * a client island: the only import is the canonical nakshatra list, never the
 * page copy in nakshatra-page-data (its presentation module is ~54 KB).
 * nakshatra-route-metadata.ts re-exports publicNakshatraSlug from here, so the
 * slug rule keeps one definition.
 */

/** "purva_phalguni" -> "purva-phalguni": the public URL segment for a canonical id. */
export function publicNakshatraSlug(id: string): string {
  return id.replace(/_/g, "-");
}

/** The page's canonical URL, with the trailing slash the site serves. */
export function nakshatraPageHref(id: string): string {
  return `/nakshatra/${publicNakshatraSlug(id)}/`;
}

function idByNumber(number: number): NakshatraId {
  const match = nakshatras.find((nakshatra) => nakshatra.number === number);
  if (!match) throw new Error(`No nakshatra number ${number}`);
  return match.id;
}

/** The nakshatras before and after `id` on the 27-star circle (Revati -> Ashwini wraps). */
export function nakshatraNeighbourIds(id: NakshatraId): {
  previous: NakshatraId;
  next: NakshatraId;
} {
  const current = getNakshatra(id);
  if (!current) throw new Error(`Unknown nakshatra id "${id}"`);
  const count = nakshatras.length;
  return {
    previous: idByNumber(((current.number + count - 2) % count) + 1),
    next: idByNumber((current.number % count) + 1),
  };
}
